import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useAuth } from "../../hooks/useAuth"
import { useWelcomeStore } from "../../stores/welcomeStore"

interface IProps {}

const ResetPassword = (props: IProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { study } = useWelcomeStore()
  const { resetPassword, passwordResetted, loading } = useAuth()
  const [inputs, setInputs] = useState({
    password: ""
  })
  const [passwordVisible, setPasswordVisible] = useState(false)
  const [searchParams] = useSearchParams()

  const reset_password_token = searchParams.get("reset-password-token") // "text"

  const resetPasswordRequestForm = (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault()
    const password = inputs["password"]
    resetPassword(password, reset_password_token)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e?.target?.name
    const value = e?.target?.value
    setInputs((values) => ({ ...values, [name]: value }))
  }

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible)
  }

  useEffect(() => {
    if (passwordResetted) navigate("/")
  }, [passwordResetted, navigate])

  return (
    <div className="flex items-center justify-center bg-cortexx-100 w-full h-screen">
      <div className="rounded-xl bg-cortexx-50 shadow-2xl p-4 pt-4">
        <div className="flex items-center justify-center my-4">
          <div className="bg-cortexx-50">
            <img
              src={
                study
                  ? study?.administrative_information.logo_url
                  : "/images/vector-logo.svg"
              }
              style={{ height: "30px" }}
              alt="RP Logo"
              loading="lazy"
            />
          </div>
        </div>
        <h1 className="font-semibold text-2xl text-cortexx-500  text-center">
          {t("auth.new_password")}
        </h1>
        <div className="flex justify-center items-cetnter w-full">
          <h2 className="text-lg text-cortexx-900 mt-8 text-center w-72">
            {t("auth.enter_new_password")}
          </h2>
        </div>
        <form className="m-6" onSubmit={resetPasswordRequestForm}>
          {!loading ? (
            <>
              <h2 className="font-semibold text-lg text-cortexx-500 pb-2">
                {t("auth.password")}
              </h2>
              <div className="flex border-2 border-slate-300 rounded-xl mb-2 leading-tight file:w-72 items-center pr-2">
                <input
                  className="py-2 px-3 text-gray-700 w-64 rounded-xl  focus:outline-none"
                  name="password"
                  type={passwordVisible ? "text" : "password"}
                  placeholder={t("auth.password")}
                  onChange={handleChange}
                />
                <img
                  src={
                    passwordVisible
                      ? "/images/eye.svg"
                      : "/images/eye_unlock.svg"
                  }
                  style={{ height: "22px" }}
                  alt="close"
                  loading="lazy"
                  onClick={togglePasswordVisibility}
                />
              </div>
            </>
          ) : (
            <div className="flex items-center justify-center">
              <img
                src="/images/fade-stagger-circles.svg"
                style={{ height: "100px" }}
                alt="close"
                loading="lazy"
              />
            </div>
          )}
          <div className="flex justify-end items-end mt-4">
            <button
              className="bg-cortexx-550 hover:opacity-60 rounded-xl py-2 px-4 text-cortexx-50 font-semibold"
              type="submit"
            >
              <p>{t("auth.submit")}</p>
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ResetPassword
